import { render, staticRenderFns } from "./EntityTemplate.vue?vue&type=template&id=5c93bad4&"
import script from "./EntityTemplate.vue?vue&type=script&lang=js&"
export * from "./EntityTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EntityTemplate.vue"
export default component.exports